<template>
  <div class="pa-6">
    <p class="text-xs-center mt-3 subheading white--text">
      Share The Love!
    </p>
    <v-layout flex row wrap justify-space-around class="ma-0">
      <v-btn
        v-for="icon in icons"
        :key="icon.name"
        class="white--text"
        icon
        :href="icon.link"
        target="_blank"
      >
        <v-icon size="24px">{{ icon.name }}</v-icon>
    </v-btn>
    </v-layout>
    <v-layout flex row wrap justify-space-around class="ma-0">
      <v-btn
        v-for="icon in icons2"
        :key="icon.name"
        class="white--text"
        icon
        :href="icon.link"
        target="_blank"
      >
        <v-icon size="24px">{{ icon.name }}</v-icon>
    </v-btn>
  </v-layout>
</div>
</template>

<script>
export default {
  data() {
    return {
      icons: [
        {
          platform: 'Like us on Facebook',
          name: 'fab fa-facebook',
          link: 'https://www.facebook.com/PlatformShe'
        },
        {
          platform: 'Follow us on Twitter',
          name: 'fab fa-twitter',
          link: 'https://twitter.com/SheToken'
        },
        {
          platform: 'Pin us on Pinterest',
          name: 'fab fa-pinterest',
          link: 'https://www.pinterest.com/sheplatform/'
        },
        {
          platform: 'Connect on Linked In',
          name: 'fab fa-linkedin',
          link: 'https://www.linkedin.com/company/she-platfrom/about/'
        }
      ],
      icons2: [
        {
          platform: 'Follow us on Instagram',
          name: 'fab fa-instagram',
          link: 'https://www.instagram.com/sheplatform/'
        },
        {
          platform: 'Follow us on Youtube',
          name: 'fab fa-youtube',
          link: 'https://www.youtube.com/channel/UCWt25n0Nm2DCb3iWL-eFXYg/featured'
        },
        {
          platform: 'Join us on Telegram',
          name: 'fab fa-telegram',
          link: 'https://t.me/ShePlatform'
        },
        {
          platform: 'Send us an email',
          name: 'fas fa-envelope',
          link: 'mailto:team@sheplatform.io'
        }
      ]
    }
  },
}
</script>

<style>

</style>
